var IdGenerator, m, setFloat;

m = require('mithril');

IdGenerator = require('../../lib/IdGenerator');

setFloat = function(prop) {
  return function(str) {
    return prop(parseFloat(str));
  };
};

module.exports = {
  controller: function(args) {
    var ctrl;
    ctrl = this;
    ctrl.name = m.prop(null);
    ctrl.weight = m.prop(null);
    ctrl.onSubmit = function(e) {
      e.preventDefault();
      args.onAdd({
        id: IdGenerator.generate(),
        name: ctrl.name(),
        position: args.centre(),
        weight: ctrl.weight()
      });
      ctrl.name(null);
      return ctrl.weight(null);
    };
    return ctrl;
  },
  view: function(ctrl, args) {
    return m('form.newMarker', {
      onsubmit: ctrl.onSubmit
    }, [
      m('input[required=required][placeholder="Namey McNameson"]', {
        value: ctrl.name(),
        onchange: m.withAttr('value', ctrl.name),
        disabled: !args.apiLoaded()
      }), m('input[type=number][required=required][min=0][placeholder=Weight]', {
        value: ctrl.weight(),
        onchange: m.withAttr('value', setFloat(ctrl.weight)),
        disabled: !args.apiLoaded()
      }), m('input[type=submit][value="Add a marker"]', {
        disabled: !args.apiLoaded()
      })
    ]);
  }
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL3VpL2NvbXBvbmVudHMvTmV3TWFya2VyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi93b3JrL3NyYy91aS9jb21wb25lbnRzL05ld01hcmtlci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxDQUFBLEdBQUksT0FBQSxDQUFRLFNBQVI7O0FBRUosV0FBQSxHQUFjLE9BQUEsQ0FBUSx1QkFBUjs7QUFFZCxRQUFBLEdBQVcsU0FBQyxJQUFEO1NBQVUsU0FBQyxHQUFEO1dBQVMsSUFBQSxDQUFLLFVBQUEsQ0FBVyxHQUFYLENBQUw7RUFBVDtBQUFWOztBQUVYLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2hCLFVBQUEsRUFBWSxTQUFDLElBQUQ7QUFDWCxRQUFBO0lBQUEsSUFBQSxHQUFPO0lBRVAsSUFBSSxDQUFDLElBQUwsR0FBWSxDQUFDLENBQUMsSUFBRixDQUFPLElBQVA7SUFDWixJQUFJLENBQUMsTUFBTCxHQUFjLENBQUMsQ0FBQyxJQUFGLENBQU8sSUFBUDtJQUNkLElBQUksQ0FBQyxRQUFMLEdBQWdCLFNBQUMsQ0FBRDtNQUNmLENBQUMsQ0FBQyxjQUFGLENBQUE7TUFDQSxJQUFJLENBQUMsS0FBTCxDQUFXO1FBQ1YsRUFBQSxFQUFJLFdBQVcsQ0FBQyxRQUFaLENBQUEsQ0FETTtRQUVWLElBQUEsRUFBTSxJQUFJLENBQUMsSUFBTCxDQUFBLENBRkk7UUFHVixRQUFBLEVBQVUsSUFBSSxDQUFDLE1BQUwsQ0FBQSxDQUhBO1FBSVYsTUFBQSxFQUFRLElBQUksQ0FBQyxNQUFMLENBQUEsQ0FKRTtPQUFYO01BTUEsSUFBSSxDQUFDLElBQUwsQ0FBVSxJQUFWO2FBQ0EsSUFBSSxDQUFDLE1BQUwsQ0FBWSxJQUFaO0lBVGU7V0FXaEI7RUFoQlcsQ0FESTtFQW1CaEIsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7V0FDTCxDQUFBLENBQUUsZ0JBQUYsRUFBb0I7TUFDbkIsUUFBQSxFQUFVLElBQUksQ0FBQyxRQURJO0tBQXBCLEVBRUc7TUFDRixDQUFBLENBQUUseURBQUYsRUFBNkQ7UUFDNUQsS0FBQSxFQUFPLElBQUksQ0FBQyxJQUFMLENBQUEsQ0FEcUQ7UUFFNUQsUUFBQSxFQUFVLENBQUMsQ0FBQyxRQUFGLENBQVcsT0FBWCxFQUFvQixJQUFJLENBQUMsSUFBekIsQ0FGa0Q7UUFHNUQsUUFBQSxFQUFVLENBQUksSUFBSSxDQUFDLFNBQUwsQ0FBQSxDQUg4QztPQUE3RCxDQURFLEVBTUYsQ0FBQSxDQUFFLGtFQUFGLEVBQXNFO1FBQ3JFLEtBQUEsRUFBTyxJQUFJLENBQUMsTUFBTCxDQUFBLENBRDhEO1FBRXJFLFFBQUEsRUFBVSxDQUFDLENBQUMsUUFBRixDQUFXLE9BQVgsRUFBb0IsUUFBQSxDQUFTLElBQUksQ0FBQyxNQUFkLENBQXBCLENBRjJEO1FBR3JFLFFBQUEsRUFBVSxDQUFJLElBQUksQ0FBQyxTQUFMLENBQUEsQ0FIdUQ7T0FBdEUsQ0FORSxFQVdGLENBQUEsQ0FBRSwwQ0FBRixFQUE4QztRQUM3QyxRQUFBLEVBQVUsQ0FBSSxJQUFJLENBQUMsU0FBTCxDQUFBLENBRCtCO09BQTlDLENBWEU7S0FGSDtFQURLLENBbkJVIn0=
